import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { PageRequest } from '../model/page-request';
import { Request } from '../model/request';
import { DemandeResurmeDTO } from 'src/app/suivi-portefeuille/core/model/resurme/demande-resurme-dto';
import { LibererDossier } from '../model/request/liberer-dossier';
import { AbandonnerDossier } from '../model/request/abandonner-dossier';
import { ReactiverDossier } from '../model/request/reactiver-dossier';
import { ChangerInitiateurDossier } from '../model/request/changer-initiateur-dossier';
import { CorrespondreDossierEtCoreBanking } from '../model/request/correspondre-dossier-et-core-banking';
import { LibererGroupDossier } from 'src/app/core/services/business/model/liberer-group-dossier';
import { AssignerGroupDossier } from 'src/app/core/services/business/model/assigner-group-dossier';
import { DeplacerGroupDossier } from 'src/app/core/services/business/model/deplacer-group-dossier';
import { ChangerEtape } from 'src/app/core/services/business/model/changer-etape';
import { PageDemandeResurmeDTO } from '../model/page-demande-resurme-dto';
import { MigrerDossier } from 'src/app/core/services/business/model/migrer-dossier';

@Injectable({
  providedIn: "root"
})
export class RequestService {
  constructor(private _restClientService: RestClientService) {}

  getRequestsHistoryByWorkflowAndUsername(
    workflow,
    filter,
    username,
    status,
    debut,
    fin,
    page,
    size,
    sortColumn,
    direction
  ) {
    return this._restClientService.load<PageRequest>(
      "request/requests-history-by-workflow-and-username" +
        "?workflow=" +
        workflow +
        "&filter=" +
        filter +
        "&username=" +
        username +
        "&status=" +
        status +
        "&debut=" +
        debut +
        "&fin=" +
        fin +
        "&page=" +
        page +
        "&size=" +
        size +
        '&sortColumn=' +
        sortColumn+
        '&direction=' +
        direction
    );
  }

  getRequestsHistoryByInitiateur(
    workflow,
    filter,
    username,
    status,
    debut,
    fin,
    page,
    size
  ) {
    return this._restClientService.load<PageDemandeResurmeDTO>(
      "request/requests-history-by-initiateur" +
        "?workflow=" +
        workflow +
        "&filter=" +
        filter +
        "&username=" +
        username +
        "&status=" +
        status +
        "&debut=" +
        debut +
        "&fin=" +
        fin +
        "&page=" +
        page +
        "&size=" +
        size
    );
  }

  getRequestById(requestId) {
    return this._restClientService.load<Request>(
      "request/request-by-id/" + requestId
    );
  }

  findResurmerDemandeByRefCoreBanking(refcorebanking) {
    return this._restClientService.load<DemandeResurmeDTO>(
      "request/resurmer-demande-by-refcorebanking/" + refcorebanking
    );
  }

  findResurmerDemandeByCodeClient(codeClient) {
    return this._restClientService.load<DemandeResurmeDTO[]>(
      "request/resurmer-demande-by-code-client/" + codeClient
    );
  }

  getRequestsByCodeClient(codeclient) {
    return this._restClientService.load<Request[]>(
      "request/requests-by-codeclient?codeclient=" + codeclient
    );
  }

  getRequestByRendezvousid(rendezvousid) {
    return this._restClientService.load<Request[]>(
      "request/requests-by-rendezvous?rendezvousid=" + rendezvousid
    );
  }

  liberer(libererDossier: LibererDossier) {
    return this._restClientService.put<void>(`request/liberer`, libererDossier);
  }

  abandonner(abandonnerDossier: AbandonnerDossier) {
    return this._restClientService.put<void>(
      `request/abandonner`,
      abandonnerDossier
    );
  }

  reactiver(reactiverDossier: ReactiverDossier) {
    return this._restClientService.put<void>(
      `request/reactiver`,
      reactiverDossier
    );
  }

  changerInitiateur(changerInitiateurDossier: ChangerInitiateurDossier) {
    return this._restClientService.put<void>(
      `request/changer-initiateur`,
      changerInitiateurDossier
    );
  }

  saveNumDossierCoreBanking(
    correspondreDossierEtCoreBanking: CorrespondreDossierEtCoreBanking
  ) {
    return this._restClientService.put<void>(
      `request/correspondre-dossier-et-corebancking`,
      correspondreDossierEtCoreBanking
    );
  }

  getRequestEncoursAttentePaiementByNumDossier(numdossier) {
    return this._restClientService.load<Request>(
      "request/request-encours-en-attente-paiement-by-numdossier/" + numdossier
    );
  }

  getRequestEncoursAttentePaiementByCodeclient(codeclient) {
    return this._restClientService.load<Request>(
      "request/request-encours-en-attente-paiement-by-codeclient/" + codeclient
    );
  }

  delete(requestId) {
    return this._restClientService.delete<any>("request/delete/" + requestId);
  }

  libererGroupDossier(libererGroupDossier: LibererGroupDossier) {
    return this._restClientService.put<void>(
      `request/liberer-group-dossier`,
      libererGroupDossier
    );
  }

  assignerGroupDossier(assignerGroupDossier: AssignerGroupDossier) {
    return this._restClientService.put<void>(
      `request/assigner-group-dossier`,
      assignerGroupDossier
    );
  }

  deplacerGroupDossierDansAregulariser(
    deplacerGroupDossier: DeplacerGroupDossier
  ) {
    return this._restClientService.put<void>(
      `request/deplacer-group-dossier-dans-a-regulariser`,
      deplacerGroupDossier
    );
  }

  deplacerGroupDossierDansNormal(deplacerGroupDossier: DeplacerGroupDossier) {
    return this._restClientService.put<void>(
      `request/deplacer-group-dossier-dans-normal`,
      deplacerGroupDossier
    );
  }

  changerEtape(changerEtape: ChangerEtape) {
    return this._restClientService.save<void>(
      `request/changer-etape`,
      changerEtape
    );
  }

  migrerDossier(migrerDossier: MigrerDossier) {
    return this._restClientService.save<void>(
      `request/migrer-dossier`,
      migrerDossier
    );
  }

}      

    